import { Expose, Transform } from "class-transformer";
import { ProfileSections } from "../../constants/profile-sections.enum";
import type { IProfileSection } from "./profile-section.entity.interface";

const BACKEND_TO_FRONTEND_SECTION_ID_MAP: Record<string, ProfileSections> = {
  personal_data: ProfileSections.PERSONAL_DATA,
  activity: ProfileSections.ACTIVITY,
  household: ProfileSections.HOUSEHOLD,
  living_situation: ProfileSections.LIVING_SITUATION,
  isee: ProfileSections.ISEE,
  income: ProfileSections.INCOME,
};

function mapSectionIdToFrontend(backendId: string): ProfileSections {
  const frontendId = BACKEND_TO_FRONTEND_SECTION_ID_MAP[backendId];
  if (!frontendId) {
    throw new Error(`Section ID ${backendId} not found in map`);
  }

  return frontendId;
}

export class ProfileSection implements IProfileSection {
  @Expose()
  @Transform(function transformSectionId({ value }) {
    const sectionId = mapSectionIdToFrontend(value);
    return sectionId;
  })
  id!: ProfileSections;

  @Expose()
  isComplete!: boolean;

  @Expose()
  hasQuestionMark?: boolean;
}
